import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerCardStyles = css`
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(3)};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.floating};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
`;
